import invert from 'lodash/invert';
import toLower from 'lodash/toLower';
import { tickerMap } from './generated';
// As of 2022/06/13 (ETH/BTC/COSMOS assets)
const assetIdToCoinbaseTickerMap = tickerMap;
const coinbaseAssetIdToAssetIdMap = invert(assetIdToCoinbaseTickerMap);
export const coinbaseTickerToAssetId = (id) => coinbaseAssetIdToAssetIdMap[id];
export const assetIdToCoinbaseTicker = (assetId) => assetIdToCoinbaseTickerMap[toLower(assetId)];
